import { StateCreator } from "zustand";
import { ReportDetailState } from "../interface";
import { getGlobalForceSave } from "../autoSaveGlobal";

const AUTO_SAVE_DELAY = 5000;

export interface AutoSaveActions {
  scheduleAutoSave: () => void;
  cancelAutoSave: () => void;
  isPendingSave: () => boolean;
  hasPendingChanges: () => boolean;
  setAutoSaveMutation: (mutation: any) => void;
  setAutoSavePending: (isPending: boolean) => void;
  setAutoSaveEnabled: (enabled: boolean) => void;
  clearPendingChanges: () => void;
}

export const createAutoSaveActions: StateCreator<
  ReportDetailState & { actions: any },
  [],
  [],
  AutoSaveActions
> = (set, get) => ({
  scheduleAutoSave: () => {
    const state = get();

    set((state) => ({
      autoSave: {
        ...state.autoSave,
        hasPendingChanges: true,
      },
    }));

    if (!state.autoSave.isEnabled) {
      return;
    }

    // Cancela salvamento pendente se existir
    if (state.autoSave.isPending && state.autoSave.mutation) {
      state.autoSave.mutation.reset();
      set((state) => ({
        autoSave: {
          ...state.autoSave,
          isPending: false,
        },
      }));
    }

    // Limpa timeout anterior
    if (state.autoSave.timeoutId) {
      clearTimeout(state.autoSave.timeoutId);
    }

    // Agenda novo salvamento
    const timeoutId = setTimeout(() => {
      const forceSave = getGlobalForceSave();
      if (forceSave) {
        forceSave();
      }
    }, AUTO_SAVE_DELAY);

    set((state) => ({
      autoSave: {
        ...state.autoSave,
        timeoutId,
      },
    }));
  },

  cancelAutoSave: () => {
    const state = get();
    if (state.autoSave.timeoutId) {
      clearTimeout(state.autoSave.timeoutId);
    }
    set((state) => ({
      autoSave: {
        ...state.autoSave,
        timeoutId: null,
        hasPendingChanges: false,
      },
    }));
  },

  isPendingSave: () => get().autoSave.isPending,

  hasPendingChanges: () => get().autoSave.hasPendingChanges,

  setAutoSaveMutation: (mutation) =>
    set((state) => ({
      autoSave: { ...state.autoSave, mutation },
    })),

  setAutoSavePending: (isPending) =>
    set((state) => ({
      autoSave: { ...state.autoSave, isPending },
    })),

  setAutoSaveEnabled: (enabled) => {
    // Persistir no localstora para manter o estado entre refreshes
    try {
      localStorage.setItem("snap-reports:autosave-enabled", String(enabled));
    } catch (error) {
      console.warn("[Autosave] Failed to save preference:", error);
    }

    set((state) => ({
      autoSave: { ...state.autoSave, isEnabled: enabled },
    }));
  },

  clearPendingChanges: () =>
    set((state) => ({
      autoSave: {
        ...state.autoSave,
        hasPendingChanges: false,
      },
    })),
});
